export const InCallControlsTestIds = {
  HANGUP: 'mobile-call.hangup-button',
};
